module.exports = __webpack_public_path__ + "src/img/artist/work07_3.jpg?acb8d8ca8b6788b2ddc9cd7569d84bd8";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work07_3.jpg
// module id = 160
// module chunks = 0